<ng-container *transloco="let t">
  <div class="dialog-overlay" (click)="onOverlayClick($event)">
    <div
      class="dialog-container"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleId"
      [attr.aria-describedby]="descriptionId"
      cdkTrapFocus
      (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h2 class="dialog-title" [id]="titleId">
          {{ t('lang.authenticating_long_wait_dialog_title') }}
        </h2>
        <button
          type="button"
          class="close-button"
          (click)="onAcknowledge()">
          <mzic-svg src="assets/icons/mzic-close.svg" />
        </button>
      </div>

      <div class="dialog-content">
        <div class="info-card">
          <div class="info-icon">
            <mzic-svg src="assets/icons/mzic-info.svg" />
          </div>
          <div class="info-copy">
            <p class="dialog-description" [id]="descriptionId">
              {{ t('lang.authenticating_long_wait_dialog_body') }}
            </p>
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <button
          type="button"
          class="primary-button"
          cdkFocusInitial
          (click)="onAcknowledge()">
          {{ t('lang.authenticating_long_wait_dialog_acknowledge') | uppercase }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
